import SideBar from './SideBar.js';

export default SideBar;
